import { render } from "./CreatineTest.vue?vue&type=template&id=4cba5787&scoped=true&ts=true"
import script from "./CreatineTest.vue?vue&type=script&lang=ts"
export * from "./CreatineTest.vue?vue&type=script&lang=ts"

import "./CreatineTest.vue?vue&type=style&index=0&id=4cba5787&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cba5787"]])

export default __exports__